import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import VueGtag from "vue-gtag";

Vue.component('vue-phone-number-input', VuePhoneNumberInput);
Vue.config.productionTip = false

Vue.filter('localized', function (value) {
  if (!value) return ''
  if(i18n.locale === 'en'){
    return value.english;
  }else {
    return value.arabic;
  }
})

Vue.use(VueGtag, {
  config: { id: "G-YF9KK7PLJS" }
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
